import { render, staticRenderFns } from "./TaskDueDateChangedActivity.vue?vue&type=template&id=67ef7c5e"
import script from "./TaskDueDateChangedActivity.vue?vue&type=script&lang=js"
export * from "./TaskDueDateChangedActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports